<div [ngSwitch]="view">
	<div *ngSwitchCase="'Start'">
		<div class="main-container">
			<div class="container">
				<div class="row justify-content-center">
					<div class="col-12">
						<start-button (notify)="onStart($event)"></start-button>
					</div>
				</div>
			</div>
		</div>
		<footerapp></footerapp>
	</div>
	<div *ngSwitchCase="'Test'" [@enterTrigger]="'fadeIn'">
		<test (notify)="onEnd($event)"></test>
	</div>
	<div *ngSwitchCase="'Result'" [@enterTrigger]="'fadeIn'">
		<result (notify)="restart($event)"></result>
	</div>
	<div *ngSwitchDefault>
		<!-- Default -->
	</div>
</div>